import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Typography } from "@mui/material";
import FormField from "../../../../components/common/FormField";
import CustomButton from "../../../../components/common/button/CustomButton";
import { customPortalInfoFields } from "./customFieldUtils";
import {
  getCustomerSettingResponseAction,
  setUpdateCustomerSettingAction,
  updateCustomerSettingAction,
} from "../../../../store/reducers/customerSlice";
import PageTitle from "../../../../components/pageTitle/PageTitle";

interface ConfirmationStage {
  stage: string;
  description: string;
}

interface CustomerPortalSettingType {
  portal_link_timeout: string;
  otp_timeout: string;
  portal_session_timeout: string;
  confirmation_text: ConfirmationStage[];
}

const CustomerPortalSetting = () => {
  const dispatch = useDispatch();

  const { customerSettingResponse, isCustomerSettingResponse } = useSelector(
    (state: any) => state?.customer,
  );

  const [customerData, setCustomerData] = useState<CustomerPortalSettingType>({
    portal_link_timeout: "24",
    otp_timeout: "10",
    portal_session_timeout: "4",
    confirmation_text: [],
  });

  const [error, setError] = useState<any>({});

  useEffect(() => {
    dispatch(getCustomerSettingResponseAction());
  }, [dispatch]);

  useEffect(() => {
    if (isCustomerSettingResponse) {
      dispatch(getCustomerSettingResponseAction());
      dispatch(setUpdateCustomerSettingAction(false));
    }
  }, [isCustomerSettingResponse]);

  useEffect(() => {
    if (customerSettingResponse) {
      const data = customerSettingResponse;

      setCustomerData({
        portal_link_timeout: data?.portal_link_timeout || "24",
        otp_timeout: data?.otp_timeout || "10",
        portal_session_timeout: data?.portal_session_timeout || "4",
        confirmation_text: data?.confirmation_text || [],
      });
    }
  }, [customerSettingResponse]);

  const onChangeAction = (e: any) => {
    const { name, value } = e.target;

    setCustomerData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStageChange = (index: number, value: string) => {
    const updatedStages = [...customerData.confirmation_text];

    updatedStages[index] = {
      ...updatedStages[index],
      description: value,
    };

    setCustomerData((prev) => ({
      ...prev,
      confirmation_text: updatedStages,
    }));
  };

  const handleSubmit = () => {
    const payload = {
      portal_link_timeout: customerData.portal_link_timeout,
      otp_timeout: customerData.otp_timeout,
      confirmation_text: customerData.confirmation_text,
    };

    console.log("Payload", payload);

    dispatch(updateCustomerSettingAction(payload));
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <Typography variant="h5" fontWeight={700}>
          Customer Portal 
        </Typography>

        <Grid
          container
          spacing={2}
          sx={{
            padding: "10px",
            mt: 1,
            background: "#E5F4F1",
            borderRadius: "5px",
          }}
        >
          <Grid item md={12} xs={12} sx={{ padding: "10px" }}>
            <Grid container spacing={2}>
              {/* Dynamic Fields */}
              {customPortalInfoFields?.map((field) => (
                <FormField
                  key={field.id}
                  onKeyDown={(event: any) => {
                    if (
                      event.keyCode === 8 ||
                      event.keyCode === 9 ||
                      event.keyCode === 37 ||
                      event.keyCode === 38 ||
                      event.keyCode === 39 ||
                      event.keyCode === 40 ||
                      event.keyCode === 18 ||
                      event.keyCode === 17 ||
                      event.ctrlKey
                    )
                      return event;

                    const newValue = event.target.value + event.key;

                    const isFloatPattern =
                      field?.patternAllowed?.source?.includes("\\.");

                    if (isFloatPattern) {
                      const floatRegex = /^\d*\.?\d*$/;
                      if (!floatRegex.test(newValue)) {
                        event.preventDefault();
                      }
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(event.key)
                    ) {
                      event.preventDefault();
                    } else if (
                      field?.patternAllowed &&
                      !field?.patternAllowed.test(newValue)
                    ) {
                      event.preventDefault();
                    }
                  }}
                  {...{
                    ...field,
                    value:
                      customerData[
                        field.id as keyof CustomerPortalSettingType
                      ] || "",
                    variant: "outlined",
                    minRows: 2,
                    inSingleGridForm: true,
                    isNonMarginTop: true,
                    onChange: onChangeAction,
                    name: field.id,
                    maxLength: 250,
                    InputProps: {
                      ...(field?.inputProps && field?.inputProps),
                      sx:
                        field?.type === "text" || field?.type === "password"
                          ? { height: "36px" }
                          : {
                              padding: "10px 4px",
                              height: "36px",
                            },
                    },
                    error: error && error[field?.id],
                  }}
                />
              ))}

              {/* Stage Description */}
              {/* <Typography variant="h5">Confirmation Text</Typography> */}
              <Grid item xs={12}>
                {customerData?.confirmation_text?.map((item, index) => (
                  <FormField
                    id=""
                    key={index}
                    label={item.stage}
                    type="textarea"
                    value={item.description}
                    md={12}
                    minRows={2}
                    inSingleGridForm
                    // isNonMarginTop
                    onChange={(e: any) =>
                      handleStageChange(index, e.target.value)
                    }
                  />
                ))}
              </Grid>
            </Grid>
          </Grid>

          {/* Save Button */}
          <Grid
            item
            md={12}
            xs={12}
            display={"flex"}
            justifyContent={"flex-end"}
          >
            <CustomButton
              style={{ width: "120px" }}
              title={"Save"}
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default CustomerPortalSetting;
